/** Tetapan -> Perancangan -> Prosedur, medan peranan dan varian kes (Fasa 2 P2-2b, P21-P22). */
export default {
  procedure: {
    title: 'Pelarasan prosedur',
    description:
      'Namakan semula langkah, tinggalkan langkah pilihan, tetapkan tempoh dalam had yang dibenarkan oleh prosedur dan senaraikan dokumen tambahan. Langkah berkanun dikunci. Kes yang sudah dibuka mengekalkan prosedur asalnya.',
    base: 'Prosedur {{id}}, versi {{version}}',
    active: 'Pelarasan yang digunakan: {{hash}}',
    none: 'Tiada pelarasan: kes baharu mengikut prosedur yang diterbitkan.',
    outdated:
      'Pelarasan ini dibuat untuk versi prosedur yang lebih lama. Kes baharu masih menggunakannya; simpan semula untuk menggunakannya pada versi semasa.',
    unavailable:
      'Pelarasan yang digunakan tidak dapat dimuatkan, jadi kes baharu tidak dapat dibuat. Simpan semula atau gunakan prosedur yang diterbitkan.',
    locked: 'Dikunci (berkanun)',
    labelIn: 'Nama dalam {{locale}}',
    stages: 'Langkah',
    transitions: 'Tindakan',
    clocks: 'Tempoh',
    skip: 'Tinggalkan langkah ini',
    durations: 'Panjang tempoh',
    durationRange: 'Antara {{min}} dan {{max}}',
    durationFixed: 'Ditetapkan oleh prosedur',
    durationTable: 'Jadual peraturan menetapkannya; nilai ini digunakan apabila tiada peraturan sepadan.',
    documentTypes: 'Dokumen tambahan',
    documentTypesHint:
      'Disenaraikan pada setiap kes baharu. Muat naik dokumen ini akan datang dalam keluaran kemudian.',
    documentTypeId: 'Kod',
    documentTypeLabel: 'Nama dokumen',
    documentTypeExtensions: 'Jenis fail (contohnya .pdf, .jpg)',
    addDocumentType: 'Tambah dokumen',
    removeDocumentType: 'Buang',
    save: 'Simpan pelarasan',
    saving: 'Menyimpan pelarasan…',
    saved: 'Pelarasan disimpan. Kes baharu mengikutinya.',
    deactivate: 'Gunakan prosedur yang diterbitkan',
    deactivated: 'Kes baharu mengikut prosedur yang diterbitkan.',
    invalid: 'Pelarasan ini ditolak:',
    issues: {
      overlay_base_mismatch:
        'Prosedur telah berubah selepas halaman ini dibuka. Muat semula halaman dan simpan sekali lagi.',
      overlay_unknown_element:
        'Satu langkah, tindakan atau tempoh dalam pelarasan ini tiada dalam prosedur semasa. Muat semula halaman dan cuba lagi.',
      overlay_touches_locked:
        'Langkah, tindakan dan tempoh yang dikunci (berkanun) tidak boleh dinamakan semula atau diubah, dan sesuatu langkah tidak boleh ditinggalkan jika ia akan mengubah salah satu daripadanya.',
      overlay_invalid_label: 'Setiap nama memerlukan 1 hingga 200 aksara.',
      overlay_skip_not_optional: 'Hanya langkah pilihan boleh ditinggalkan.',
      overlay_duration_not_adjustable: 'Tempoh yang ditetapkan oleh prosedur tidak boleh diberi panjang lain.',
      overlay_duration_out_of_bounds: 'Panjang tempoh mestilah nombor bulat dalam julat yang ditunjukkan di bawahnya.',
      overlay_document_type_invalid:
        'Setiap dokumen tambahan memerlukan kod 2 hingga 40 huruf kecil, digit atau garis bawah yang bermula dengan huruf (contohnya gambar_tapak) dan belum digunakan, nama, serta 1 hingga 10 jenis fail seperti .pdf. Paling banyak 20 dokumen tambahan.',
    },
    download: 'Muat turun prosedur:',
    downloadJson: 'Fail JSON',
    downloadBpmn: 'Rajah BPMN 2.0',
    downloadDmn: 'Jadual peraturan DMN 1.3',
    loadFailed: 'Prosedur tidak dapat dimuatkan.',
    caseDocumentTypes: 'Dokumen yang diminta oleh prosedur ini: {{list}}',
  },
  roles: {
    groupsFor: 'Kumpulan untuk peranan {{role}}',
    hint: 'Ahli dengan peranan pentadbir atau penerbit bertindak dalam peranan ini di mana sahaja prosedur menamakannya.',
  },
} as const
